export default "__VITE_ASSET__db3d08bf__"